import { inject } from '@angular/core';
import type { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ReadUserGuard } from '@dtis/angular';
import { LandingPageComponent } from '../pages/landing-page.component';
import { BusinessUnitManagementComponent } from './pages/business-unit-management-page/business-unit-management/business-unit-management.component';

export const appRoutes: Route[] = [
  {
    path: 'forbidden',
    loadChildren: async () => import('@schaeffler/empty-states').then((m) => m.ForbiddenModule),
    data: {
      headingText: 'Forbidden',
      messageText: 'Sorry, you dont have access to this page',
      label: 'Forbidden',
    },
  },
  {
    path: 'business-unit-management',
    component: BusinessUnitManagementComponent,
    data: {
      label: 'Business Unit Management',
    },
  },
  {
    path: 'business-unit-management/:id',
    component: BusinessUnitManagementComponent,
    data: {
      label: 'Business Unit Management',
    },
  },
  {
    path: '**',
    component: LandingPageComponent,
    canActivate: [MsalGuard],
    canActivateChild: [() => inject(ReadUserGuard).canActivateChild()],

    data: {
      defaultRoute: true,
      label: 'Home',
    },
  },
];
